import { useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import KPIWidget from "src/components/KPIWidget";
import Title from "src/components/Title";
import useAuth from "../services/hooks/useAuth";

const DATE_RANGE_OPTIONS = [
  { value: "today", label: "Heute" },
  { value: "this_week", label: "Diese Woche" },
  { value: "last_7_days", label: "Letzte 7 Tage" },
  { value: "this_month", label: "Dieser Monat" },
  { value: "this_year", label: "Dieses Jahr" },
];

const toStartOfDay = (date) => {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getDateRange = (range) => {
  const now = new Date();
  const end = toStartOfDay(now);
  let start = new Date(end);

  switch (range) {
    case "today":
      start = new Date(end);
      break;
    case "this_week": {
      const currentDay = end.getDay();
      const dayOffset = currentDay === 0 ? 6 : currentDay - 1;
      start.setDate(end.getDate() - dayOffset);
      break;
    }
    case "last_7_days":
      start.setDate(end.getDate() - 6);
      break;
    case "this_month":
      start = new Date(end.getFullYear(), end.getMonth(), 1);
      break;
    case "this_year":
      start = new Date(end.getFullYear(), 0, 1);
      break;
    default:
      start.setDate(end.getDate() - 6);
  }

  return {
    startDate: formatDate(start),
    endDate: formatDate(end),
  };
};

const MainSite = () => {
  const { user } = useAuth();
  const [selectedRange, setSelectedRange] = useState("last_7_days");

  const { startDate, endDate } = useMemo(
    () => getDateRange(selectedRange),
    [selectedRange],
  );

  return (
    <>
      <Row className="g-3 align-items-end">
        <Col md={8}>
          <Title>Hallo {user.first_name}</Title>
        </Col>
        <Col md={4}>
          <Form.Group controlId="kpiDateRange">
            <Form.Label>Zeitraum</Form.Label>
            <Form.Select
              value={selectedRange}
              onChange={(event) => setSelectedRange(event.target.value)}
            >
              {DATE_RANGE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} sm={6} md={4} lg={2}>
          <KPIWidget
            title="Neue Benutzer"
            kpiType="new_users"
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <KPIWidget
            title="Neue Swipes"
            kpiType="new_swipes"
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <KPIWidget
            title="Geänderte Swipes"
            kpiType="changed_swipes"
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <KPIWidget
            title="Suchanfragen"
            kpiType="searches"
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <KPIWidget
            title="Positive Swipes"
            kpiType="positive_swipes"
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={2}>
          <KPIWidget
            title="Negative Swipes"
            kpiType="negative_swipes"
            startDate={startDate}
            endDate={endDate}
          />
        </Col>
      </Row>
    </>
  );
};

export default MainSite;
